/**
 * CrankWheel Screen Sharing
 *
 * Its five web-accessible resources — the extension popup UI and its scripts — are
 * matched only to CrankWheel's own origins (its site and meeting.is), not to every
 * page, with no `use_dynamic_url`. The files are static and vendor-named (`ext_`
 * prefix), so they load at a fixed URL, but only from those origins.
 *
 * So this extension IS detectable, but only by CrankWheel's own site. From any other
 * origin the resources are unreachable and a negative result proves nothing — a good
 * example of scoping a resource to where it is actually needed.
 *
 * Manifest verified against version 8.17.0.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dooinopjfnhlmmdkdepajfipfhlcmjgp';

export const crankwheel: ExtensionDefinition = {
  id: ID,
  name: 'CrankWheel Screen Sharing',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  requiredOrigin: 'https://www.crankwheel.com',
  notes:
    'Five static WAR scoped to *.crankwheel.com and *.meeting.is, so only those sites ' +
    'can detect it. The ext_-prefixed scripts are conclusive from a matching origin.',
  signals: [
    {
      id: 'war-ext-common-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/ext_common.js — a vendor-namespaced (ext_) script, static but only ' +
        'exposed to CrankWheel origins.',
      weight: 1,
      run: () => probeFetch(ID, 'js/ext_common.js'),
    },
    {
      id: 'war-ext-popup-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch html/ext_popup.html — the popup UI page, a second origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/ext_popup.html'),
    },
    {
      id: 'war-ext-popup-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/popup/ext_popup.js — the popup script, independent of the other two.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/popup/ext_popup.js'),
    },
  ],
};
